import axios from "axios";
import store from "@/store";
import router from "@/router";
import {
  baseURL,
  contentType,
  debounce,
  loadingText,
  requestTimeout,
  secrecy,
  tokenName,
} from "@/config/net.config";
import blueTower from "@/utils/blue-tower";
import {Loading, Notification} from "element-ui";

let loadingInstance;

const CODE_MESSAGE = {
  0: "未可知错误，可能是因为后端不支持跨域CORS、接口地址不存在等问题引起！",
  1: "服务器成功返回请求数据！",
  200: "服务器成功返回请求数据！",
  // 201: "新建或修改数据成功",
  // 202: "一个请求已经进入后台排队(异步任务)",
  204: "删除数据成功！",
  400: "发出信息有误！",
  4001: "身份验证失败！",
  4002: "身份验证已过期！",
  4003: "没有访问权限！",
  403: "请求被拒绝！",
  404: "访问资源不存在！",
  405: "不支持当前请求方法！",
  415: "不支持当前媒体类型！",
  40101: "令牌更新！",
  40102: "重试次数密集！",
  500: "服务器发生错误！",
  3012: "该文件暂不支持预览！",
  // 502: "网关错误",
  // 503: "服务不可用，服务器暂时过载或维护",
  // 504: "网关超时",
};

const handleData = ({data, status = 0, headers, statusText}) => {
  if (loadingInstance) loadingInstance.close();
  // 若data.code存在，覆盖默认code
  // let code = data && data.code ? data.code : status;
  const resultData =
      secrecy && headers.encry === "true"
          ? JSON.parse(blueTower.decrypts(data, headers.code))
          : data;
  let code = resultData && resultData.code ? resultData.code : status;
  switch (code) {
    case 1:
      return resultData;
    case 200: {
      if (resultData && resultData.code === 0) {
        Notification.error({
          title: "错误",
          message: resultData.message,
        });
      }
      return resultData;
    }
    case 4001:
      store.dispatch("resetAll").then(() => {
        router
          .push({
            path: "/login",
          })
          .then(() => {
          });
      });
      return Notification.error({
        title: "错误",
        message: `${
          data && data.message
            ? data.message
            : CODE_MESSAGE[code]
              ? CODE_MESSAGE[code]
              : statusText
        }`,
      });
    case 4002:
      store.dispatch("resetAll").then(() => {
        router
          .push({
            path: "/login",
          })
          .then(() => {
          });
      });
      return Notification.error({
        title: "错误",
        message: `${
          data && data.message
            ? data.message
            : CODE_MESSAGE[code]
              ? CODE_MESSAGE[code]
              : statusText
        }`,
      });
    case 4003:
      router.push("/403").then(() => {
      });
      break;
    case 4005:
      router.push("/rP/reset").then(() => {
      });
      return Notification.warning({
        title: "提示",
        message: `${
          data && data.message
            ? data.message
            : CODE_MESSAGE[code]
              ? CODE_MESSAGE[code]
              : statusText
        }`,
      });
  }
  // 异常处理
  // 若data.msg存在，覆盖默认提醒消息
  const message = `${
    data && data.message
      ? data.message
      : CODE_MESSAGE[code]
        ? CODE_MESSAGE[code]
        : statusText
  }`;
  Notification.error({
    title: "错误",
    message,
  });
  return data;
};

// 创建axios实例
const service = axios.create({
  baseURL, // api 的 base_url
  timeout: requestTimeout, // 请求超时时间
  headers: {
    "Content-Type": contentType,
  },
});

// request拦截器
service.interceptors.request.use(
  (config) => {
    config.headers["token"] = localStorage.getItem(tokenName);
    let f = config.data instanceof FormData;
    if (secrecy === true) {
      let code = getUUID();
      if (config.method === "post" || config.method === "POST") {
        if (config.data !== undefined) {
          if (!f) {
            if (config.headers["flag"] !== false) {
              let data = blueTower.encrypts(JSON.stringify(config.data), code);
              config.headers["encry"] = "true";
              config.headers["code"] = code;
              config.data = {data: data};
            } else {
              config.headers["encry"] = "true";
              config.headers["code"] = code;
            }
          }
        } else {
          config.headers["encry"] = "true";
          config.headers["code"] = code;
        }
      } else if (config.method === "get" || config.method === "GET") {
        if (config.params !== undefined) {
          if (!f) {
            if (config.headers["flag"] !== false) {
              config.headers["encry"] = "true";
              config.headers["code"] = code;
              config.params = {
                data: blueTower.encrypts(JSON.stringify(config.params), code),
              };
            } else {
              config.headers["encry"] = "true";
              config.headers["code"] = code;
            }
          }
        } else {
          config.headers["encry"] = "true";
          config.headers["code"] = code;
        }
      }
    }
    if (debounce.some((item) => config.url.includes(item))) {
      // 开启全局加载框
      loadingInstance = Loading.service({
        lock: true,
        text: loadingText,
        spinner: null,
        background: "hsla(0,0%,100%,.8)",
      });
    }
    return config;
  },
  (error) => {
    // Do something with request error
    Promise.reject(error).then(() => {
    });
  }
);

// response 拦截器
service.interceptors.response.use(
  (response) => handleData(response),
  (error) => {
    const {response = {}} = error;
    return handleData(response);
  }
);

export default service;

/**
 * 获取uuid
 * @returns {string}
 */
export function getUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
    .replace(/[xy]/g, (c) => {
      return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
        16
      );
    })
    .replace(/-/g, "");
}
